module.exports = __webpack_public_path__ + "static/media/PressStart2P-Regular.f98cd910.ttf";